import { useTranslation } from "react-i18next";
import { Avatar } from "@/shared/ui";
import type { WorkerListItem } from "../../../types";
import EmployeeSocialCategoryIcons from "./EmployeeSocialCategoryIcons";

interface Props {
  employee: WorkerListItem;
}

export default function EmployeeNameCell({ employee }: Props) {
  const { t } = useTranslation("EmployeesPage");
  const categories = employee.social_categories ?? [];

  return (
    <div className="flex items-center gap-3">
      <Avatar name={employee.full_name} size={36} />
      <div className="flex flex-col min-w-0">
        <div className="flex items-center gap-1">
          <span className="text-label-sm content-base-primary truncate max-w-[200px]" title={employee.full_name}>{employee.full_name}</span>
          {categories.length > 0 && <EmployeeSocialCategoryIcons categories={categories} />}
        </div>
        <span className="text-body-regular-xs content-base-secondary">{t("table.iinPrefix", { iin: employee.iin || "—" })}</span>
      </div>
    </div>
  );
}
